import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon, LockIcon, ZapIcon, ShieldCheckIcon, MailIcon, GlobeIcon } from 'lucide-react';
const fadeUp = {
  hidden: {
    opacity: 0,
    y: 30
  },
  show: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6
    }
  }
};
interface CTABlockProps {
  onCTAClick: () => void;
}
export function CTABlock({
  onCTAClick
}: CTABlockProps) {
  return <motion.div variants={fadeUp} initial="hidden" whileInView="show" viewport={{
    once: true
  }} className="text-center bg-[#111111] border border-[#D4AF37]/30 rounded-3xl max-sm:rounded-2xl p-8 max-sm:p-5 md:p-12 shadow-[0_0_50px_rgba(212,175,55,0.1)]" data-id="element-15">
      <h2 className="text-3xl max-sm:text-xl md:text-4xl font-serif font-black text-[#E8E0D0] mb-6 max-sm:mb-4 uppercase tracking-tight" data-id="element-16">
        🔥 SÍ, QUIERO ACCESO COMPLETO POR $12.97
      </h2>

      <p className="text-lg text-[#A09880] mb-3" data-id="element-17">
        📘 Guía + 🎧 Audiolibro + 4 Bonos exclusivos — todo incluido
      </p>
      <p className="text-sm text-[#A09880]/70 mb-6" data-id="element-18">
        Descarga inmediata. Acceso instantáneo. Sin suscripciones.
      </p>

      <div className="flex items-center justify-center gap-2 text-[#D4AF37] mb-4" data-id="element-19">
        {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-5 h-5 fill-current" data-id="element-20" />)}
      </div>
      <p className="text-sm font-bold text-[#D4AF37] tracking-widest uppercase mb-8" data-id="element-21">
        Producto Premium — AI Generation
      </p>

      <div className="flex items-center justify-center gap-4 max-sm:flex-col max-sm:gap-1 mb-8 max-sm:mb-5" data-id="element-22">
        <span className="text-2xl max-sm:text-lg text-[#A09880] line-through decoration-[#FF3B3B]/50 font-medium" data-id="element-23">
          Valor real: $254
        </span>
        <span className="text-4xl max-sm:text-3xl font-black text-[#D4AF37]" data-id="element-24">
          Hoy: $12.97
        </span>
      </div>

      <button onClick={onCTAClick} className="w-full min-h-[80px] max-sm:min-h-[64px] bg-[#D4AF37] hover:bg-[#B8962E] text-[#0A0A0A] font-black text-xl max-sm:text-lg md:text-2xl py-6 max-sm:py-4 px-8 max-sm:px-5 rounded-2xl shadow-[0_0_40px_rgba(212,175,55,0.3)] hover:shadow-[0_0_60px_rgba(212,175,55,0.5)] transition-all transform hover:scale-[1.02] active:scale-95 mb-6 uppercase tracking-wide" data-id="element-25">
        ¡LO QUIERO AHORA! — $12.97
      </button>

      <p className="text-sm text-[#A09880] mb-10" data-id="element-26">
        Pago 100% seguro. Acceso inmediato tras la compra.
        <br data-id="element-27" />
        Disponible en: Tarjeta de crédito / débito / PayPal
      </p>

      {/* Trust badges */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 max-sm:gap-2 text-left max-w-3xl mx-auto mb-16 max-sm:mb-10" data-id="element-28">
        <div className="flex items-center gap-3 text-[#A09880] text-sm font-light" data-id="element-29">
          <LockIcon className="w-5 h-5 text-[#D4AF37]/70 shrink-0" data-id="element-30" />
          <span data-id="element-31">Pago 100% seguro y encriptado</span>
        </div>
        <div className="flex items-center gap-3 text-[#A09880] text-sm font-light" data-id="element-32">
          <ZapIcon className="w-5 h-5 text-[#D4AF37]/70 shrink-0" data-id="element-33" />
          <span data-id="element-34">Descarga inmediata tras la compra</span>
        </div>
        <div className="flex items-center gap-3 text-[#A09880] text-sm font-light" data-id="element-35">
          <ShieldCheckIcon className="w-5 h-5 text-[#D4AF37]/70 shrink-0" data-id="element-36" />
          <span data-id="element-37">Garantía extendida de 30 días sin preguntas</span>
        </div>
        <div className="flex items-center gap-3 text-[#A09880] text-sm font-light" data-id="element-38">
          <MailIcon className="w-5 h-5 text-[#D4AF37]/70 shrink-0" data-id="element-39" />
          <span data-id="element-40">Soporte disponible en &lt; 24 horas</span>
        </div>
        <div className="flex items-center gap-3 text-[#A09880] text-sm font-light md:col-span-2 lg:col-span-1" data-id="element-41">
          <GlobeIcon className="w-5 h-5 text-[#D4AF37]/70 shrink-0" data-id="element-42" />
          <span data-id="element-43">Acceso desde cualquier dispositivo</span>
        </div>
      </div>

      {/* Final reminder */}
      <div className="border-t border-[#D4AF37]/20 pt-12 max-sm:pt-8 max-w-2xl mx-auto" data-id="element-44">
        <h3 className="text-2xl max-sm:text-xl font-serif font-bold text-[#E8E0D0] mb-6 max-sm:mb-4" data-id="element-45">
          ¿Aún tienes dudas?
        </h3>
        <p className="text-lg max-sm:text-base text-[#A09880] mb-6 max-sm:mb-4" data-id="element-46">
          Hazte esta pregunta:
        </p>
        <p className="text-xl max-sm:text-lg font-bold text-[#D4AF37] mb-8 max-sm:mb-5" data-id="element-47">
          ¿Cuánto vale para ti recuperar 2 horas al día?
        </p>
        <div className="space-y-2 text-[#A09880] mb-8 max-sm:mb-5 max-sm:text-sm" data-id="element-48">
          <p data-id="element-49">2 horas al día son 60 horas al mes.</p>
          <p data-id="element-50">60 horas al mes son 720 horas al año.</p>
        </div>
        <p className="text-2xl max-sm:text-xl font-black text-[#E8E0D0] mb-6 max-sm:mb-4" data-id="element-51">
          720 horas de tu vida devuelta.
        </p>
        <p className="text-xl max-sm:text-lg text-[#A09880] mb-8 max-sm:mb-5" data-id="element-52">
          Por $12.97.
        </p>
        <p className="text-lg max-sm:text-base font-bold text-[#D4AF37] uppercase tracking-widest" data-id="element-53">
          Una sola vez. Sin suscripciones. Sin excusas. 🧠
        </p>
      </div>
    </motion.div>;
}